import CrudList from "../components/CrudList";

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "on_trip", label: "On Trip" },
  { value: "off_duty", label: "Off Duty" },
  { value: "inactive", label: "Inactive" },
];

const FIELDS = [
  { name: "first_name", label: "First name", required: true },
  { name: "last_name", label: "Last name" },
  { name: "email", label: "Email" },
  { name: "phone", label: "Phone" },
  { name: "license_number", label: "License #" },
  { name: "license_expiry", label: "License expiry", type: "date" },
  { name: "languages", label: "Languages", type: "tags" },
  { name: "rating", label: "Rating (0-5)", type: "number" },
  { name: "status", label: "Status", type: "select", options: statusOptions, default: "active" },
  { name: "hire_date", label: "Hire date", type: "date" },
  { name: "daily_rate", label: "Daily rate", type: "number" },
  { name: "photo_url", label: "Photo URL", span: 2 },
  { name: "notes", label: "Notes", type: "textarea", span: 2 },
];

const COLUMNS = [
  { key: "name", label: "Driver", render: (c) => <div><div className="font-heading">{c.first_name} {c.last_name}</div><div className="text-xs text-muted-foreground">{c.email}</div></div> },
  { key: "phone", label: "Phone" },
  { key: "languages", label: "Languages", render: (c) => Array.isArray(c.languages) ? c.languages.join(", ") : "—" },
  { key: "rating", label: "Rating", render: (c) => c.rating ? `${c.rating} ★` : "—" },
  { key: "status", label: "Status", render: (c) => <span className="label-mono">{c.status}</span> },
];

export default function Chauffeurs() {
  return <CrudList endpoint="/chauffeurs" fields={FIELDS} columns={COLUMNS} testid="chauffeurs" emptyText="No chauffeurs yet." />;
}
